const scrollTop = {
  button: document.getElementsByClassName('scroll_up')[0],
  container: document.getElementsByClassName('scroll-up-box')[0],
  offsetTop: 400,

  init() {
    this.bindEvents();
  },

  bindEvents() {
    window.addEventListener('scroll', () => {

      if (document.documentElement.scrollTop < this.offsetTop){
        this.container.style.display = 'none';
      } else {
        this.container.style.display = 'block';
      }

    });

    this.button.addEventListener('click', () => window.scrollTo({
      top: 0,
      behavior: 'smooth',
    }))
  },

};

export default scrollTop;



// WEBPACK FOOTER //
// ./scripts/modules/scrolltop.js